/**
 * Single source of truth for all vue-query cache keys in the CA app.
 *
 * Mutations declare which entities they invalidate via `mutationOptions`'
 * `invalidation` config. The `MutationCache.onSuccess` hook in `queryClient.ts`
 * resolves each `EntityInvalidation` back to a key here and calls
 * `invalidateQueries`.
 */

export type EntityContextMap = {
  account: never
  address: never
  payment: never
  animal: never
  animalMeta: never
  product: never
  subscription: never
  order: never
  pastOrder: never
  referral: never
}

export type EntityType = keyof EntityContextMap

export type EntityInvalidation = {
  [K in EntityType]: EntityContextMap[K] extends never ? { entity: K } : { entity: K } & EntityContextMap[K]
}[EntityType]

export const entityKeys = {
  account: () => ['account'] as const,
  address: () => ['account', 'address'] as const,
  payment: () => ['account', 'payment'] as const,
  animal: () => ['animals'] as const,
  animalMeta: () => ['animals', 'meta'] as const,
  product: () => ['products'] as const,
  subscription: () => ['subscriptions'] as const,
  order: () => ['orders'] as const,
  pastOrder: () => ['orders', 'past'] as const,
  referral: () => ['referral'] as const,
} as const
